import styled from 'styled-components';
import BaseBox from '@tds/core-box';
export const TableBottomBar = styled.div`
display: flex;
justify-content: flex-end;
margin-bottom: 2rem;
padding: 0 1.8rem;
margin-right: 7%;
`;